import React from 'react';
import { productEffectivePrice } from '../productPricing';

const SORT_OPTIONS = [
  { value: 'default', label: 'Featured order' },
  { value: 'price-asc', label: 'Price: low to high' },
  { value: 'price-desc', label: 'Price: high to low' },
  { value: 'name-asc', label: 'Name: A–Z' },
];

export function sortProducts(list, sortKey) {
  const items = [...list];
  switch (sortKey) {
    case 'price-asc':
      return items.sort((a, b) => productEffectivePrice(a) - productEffectivePrice(b));
    case 'price-desc':
      return items.sort((a, b) => productEffectivePrice(b) - productEffectivePrice(a));
    case 'name-asc':
      return items.sort((a, b) =>
        String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' })
      );
    default:
      return items;
  }
}

export function filterInStockOnly(list, inStockOnly) {
  if (!inStockOnly) return list;
  return list.filter((p) => {
    const raw = p.stock_qty;
    if (raw === null || raw === undefined || raw === '') return true;
    return Number(raw) > 0;
  });
}

export default function ProductListingToolbar({
  sort,
  onSortChange,
  inStockOnly,
  onInStockOnlyChange,
  count,
  className = '',
}) {
  return (
    <div className={`product-listing-toolbar ${className}`.trim()}>
      <p className="product-listing-toolbar__count small text-muted mb-0">
        {count} design{count === 1 ? '' : 's'}
      </p>
      <div className="product-listing-toolbar__controls">
        <label className="form-check form-switch product-listing-toolbar__switch mb-0">
          <input
            type="checkbox"
            role="switch"
            className="form-check-input"
            id="listing-in-stock-only"
            checked={inStockOnly}
            onChange={(e) => onInStockOnlyChange(e.target.checked)}
          />
          <span className="form-check-label">In stock only</span>
        </label>
        <label className="product-listing-toolbar__sort">
          <span className="visually-hidden">Sort</span>
          <select
            className="form-select form-select-sm"
            value={sort}
            onChange={(e) => onSortChange(e.target.value)}
            aria-label="Sort products"
          >
            {SORT_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );
}
